////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import _ from 'lodash'

//////STYLED//////
const UsersManagerTagsComponentWrapper = styled.div`
	text-align: center;
`
//////STYLED//////

const UsersManagerTagsComponent = (props) => {
	let arr
	arr = _.map(props.row.tags, 'name')

	///////////////////////////////// RENDER ///////////////////////////////////////

	return <UsersManagerTagsComponentWrapper>{arr.join(' | ')}</UsersManagerTagsComponentWrapper>
}

UsersManagerTagsComponent.propTypes = {}

UsersManagerTagsComponent.defaultPropTypes = {}

export default UsersManagerTagsComponent
